module.exports = __webpack_public_path__ + "img/TSY_04_02.7619d084.png";